import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Avatar,
  Box,
  FormControl,
  FormHelperText,
  Grid,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import AppLoader from "../../../../components/AppLoader";
import GlobalButton from "../../../../components/CustomButton";
import Label from "../../../../components/Label";
import RomanianPhoneInput from "../../../../components/romaniaPhoneInput";
import TextInput from "../../../../components/TextInputs";
import UploadImageAvatar from "../../../../components/UploadImage";
import appcolors from "../../../../constants/Colors";
import { baseUrl } from "../../../../services";
import { getAddressDetailByPlaceId } from "../../../../services/common/CommonApiFn";
import {
  companySendCode,
  getCompanyRelatedToServices,
} from "../../../../services/company/authenticationApiFn";
import {
  getCityFromPlaces,
  getCountryFromPlaces,
  handleOpenSnackBar,
} from "../../../../utils";
import { regiterWorkerValidation } from "../../../../utils/Validation";
import { t } from "i18next";
import { GetState, GetCity } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

const useStyle = {
  selectStyle: {
    "&.MuiOutlinedInput-root .MuiSelect-outlined": {
      display: "flex",
      alignItems: "center",
      padding: "12px 14px",
    },
    "&.MuiOutlinedInput-root ": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #7922D8 `,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #7922D8 `,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #7922D8 `,
      },
    },
    "&.Mui-error ": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f `,
      },
    },
  },
};

const RegistrationForm = () => {
  const errorRef = useRef(null);
  const uploadRef = useRef();
  const theme = useTheme(null);
  const navigate = useNavigate();
  const { state } = useLocation();

  // manage states
  const [showPass, setShowPass] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const [allCompanies, setAllCompanies] = useState(null);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [location, setLocation] = useState(null);
  const [inputValues, setInputValues] = useState({
    image: null,
    name: "",
    email: "",
    contact: "",
    location: null,
    country: 181,
    state: "Bucharest",
    city: "",
    company: "",
    password: "",
    gender: "",
    expertise: "",
    workerBgImages: [],
  });

  const [inputError, setInputError] = useState({
    image: false,
    name: false,
    email: false,
    isEmailValid: false,
    contact: false,
    state: false,
    city: false,
    location: false,
    company: false,
    password: false,
    gender: false,
    expertise: false,
    workerBgImages: false,
    isPasswordStrong: false,
  });

  const fetchAllCompanies = async () => {
    try {
      setIsLoading(true);
      const response = await getCompanyRelatedToServices(
        state?.selectedServices[0]
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        setInputValues((prev) => ({ ...prev, company: data[0]._id }));
        setAllCompanies(data);
      } else {
        console.error(response.data.message, "Error fetching companies");
      }
    } catch (error) {
      console.error(error.message, "Error fetching companies");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegister = async () => {
    try {
      const validate = regiterWorkerValidation(inputValues, setInputError);
      if (validate) {
        return;
      }

      if (!location) return handleOpenSnackBar("error", t("locationRequired"));

      setIsLoading(true);

      const payload = {
        email: inputValues.email,
        purpose: "Registration",
        role: "Worker",
      };

      const response = await companySendCode(payload);

      if (response.data.status === "success") {
        navigate(`/register/worker/verification`, {
          state: {
            inputValues: { ...inputValues, workerLocation: location },
            services: state?.selectedServices,
          },
        });
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;

    if (name === "state") {
      setInputValues((prev) => ({ ...prev, city: "" }));
    }

    setInputError((prevError) => ({
      ...prevError,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
      isPasswordStrong:
        name === "password" ? false : inputError.isPasswordStrong,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };

  const handleImageChange = async (event, typee) => {
    if (event.target.files.length > 0) {
      try {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("image", event.target.files[0]);
        const response = await axios({
          method: "post",
          url: `${baseUrl}image/upload`,
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (typee) {
          setInputValues((prevValues) => ({
            ...prevValues,
            workerBgImages: [
              ...inputValues.workerBgImages,
              response?.data?.url,
            ],
          }));
          setInputError((prevError) => ({
            ...prevError,
            workerBgImages: false,
          }));
        } else {
          setInputValues((prevValues) => ({
            ...prevValues,
            image: response?.data?.url,
          }));
          setInputError((prevError) => ({
            ...prevError,
            image: false,
          }));
        }
        handleOpenSnackBar("success", t("imageUploadSuccess"));
      } catch (error) {
        handleOpenSnackBar("error", t("imageUploadFailed"));
      } finally {
        setIsLoading(false);
      }
    }
  };

  const fetchPlaceDetails = async (object) => {
    try {
      setIsLoading(true);
      const response = await getAddressDetailByPlaceId(object.value.place_id);

      if (response?.data?.status === "success") {
        const data = response.data.data;
        const lat = data.result.geometry.location.lat;
        const lng = data.result.geometry.location.lng;

        setLocation({
          address: data.result.formatted_address,
          lat,
          lng,
        });
      } else {
        setLocation(null);
        setInputError((err) => ({ ...err, location: false }));
        handleOpenSnackBar("error", t("placeDetailsUnavailable"));
      }
    } catch (error) {
      setInputError((err) => ({ ...err, location: false }));
      setLocation(null);
      handleOpenSnackBar("error", t("errorFetchingPlaceDetails"));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
    if (state?.inputValues) {
      setInputValues((pre) => ({
        ...pre,
        image: state?.inputValues.image,
        name: state?.inputValues.name,
        email: state?.inputValues.email,
        contact: state?.inputValues.contact,
        company: state?.inputValues.company,
        password: state?.inputValues.password,
        gender: state?.inputValues.gender,
        expertise: state?.inputValues.expertise,
        location: state?.inputValues.location,
        workerBgImages: state?.inputValues.workerBgImages,
        city: state?.inputValues.city,
        state: state?.inputValues.state,
      }));
      setLocation(state?.inputValues.workerLocation);
    }
  }, [state]);

  const getAllStates = async () => {
    try {
      const response = await GetState(inputValues.country);
      setAllStates(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getAllCities = async () => {
    try {
      const stateName =
        state?.inputValues?.state?.toLowerCase() ||
        inputValues.state?.toLowerCase() ||
        "";

      const findState = allStates.find(
        (val) => val.name?.toLowerCase() === stateName
      );

      const response = await GetCity(inputValues.country, findState?.id);
      setAllCities(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getAllStates();
  }, []);

  useEffect(() => {
    if (inputValues.state && allStates.length > 0) {
      getAllCities();
    }
  }, [inputValues.state, allStates]);

  return (
    <Box component={"form"} sx={{ mt: 3 }}>
      <AppLoader isVisible={isLoading} />

      {allCompanies?.length === 0 && (
        <Typography variant="body2" color={"red"}>
          {t("noCompanyProvidingService")}
        </Typography>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack alignItems={"center"}>
            <UploadImageAvatar
              error={inputError.image}
              image={inputValues.image}
              handleImageChange={handleImageChange}
            />
            {inputError.image && (
              <FormHelperText sx={{ color: "custom.errorRed" }}>
                {t("imageRequired")}
              </FormHelperText>
            )}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText={t("uploadBackgroundImages", {
              maxImagesCount: 4,
            })}
            htmlFor={"full-name"}
            required
          />
          {inputValues.workerBgImages.length < 4 && (
            <Box
              sx={{
                border: "1px solid #00000024",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "flex-start",
                padding: "10px",
                cursor: "pointer",
                width: "40px",
                height: "40px",
              }}
              onClick={() => uploadRef.current.click()}
            >
              <CameraAltIcon style={{ fontSize: "40px" }} />
            </Box>
          )}
          <input
            style={{ height: 0, width: 0, visibility: "hidden" }}
            ref={uploadRef}
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(e, "multiple")}
          />

          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {inputValues.workerBgImages.map((urlllll, inddd) => {
              return (
                <Box sx={{ position: "relative" }}>
                  <img
                    src={urlllll}
                    alt="bg"
                    style={{
                      width: "150px",
                      height: "150px",
                    }}
                  />
                  <Box
                    onClick={() => {
                      let arrrr = [...inputValues.workerBgImages];
                      arrrr.splice(inddd, 1);
                      setInputValues({
                        ...inputValues,
                        workerBgImages: arrrr,
                      });
                    }}
                    sx={{
                      position: "absolute",
                      height: "25px",
                      width: "25px",
                      background: "#fff",
                      border: "1px solid #00000024",
                      borderRadius: "50%",
                      top: "10px",
                      right: "10px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <DeleteIcon
                      style={{
                        color: "red",
                        fontSize: "20px",
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
          {inputError.workerBgImages && (
            <FormHelperText sx={{ color: "custom.errorRed" }}>
              {t("minimumImagesRequired", {
                minimumImagesCount: 2,
              })}
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <Label labelText={t("fullName")} htmlFor={"full-name"} required />
          <TextInput
            id={"full-name"}
            required={true}
            inputError={inputError.name}
            helperText={inputError.name && t("fullNameRequired")}
            placeholder={`${t("enter")} ${t("fullName")}`}
            type={"text"}
            name="name"
            value={inputValues.name}
            onChange={handleChangeValues}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            labelText={t("emailAddress")}
            htmlFor={"email-address"}
            required
          />
          <TextInput
            id={"email-address"}
            required={true}
            inputError={inputError.email || inputError.isEmailValid}
            helperText={
              inputError.email
                ? t("emailRequired")
                : inputError.isEmailValid
                ? t("invalidEmailFormat")
                : null
            }
            placeholder={`${t("enter")} ${t("emailAddress")}`}
            type={"email"}
            name="email"
            value={inputValues.email}
            onChange={handleChangeValues}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            labelText={t("contactNumber")}
            htmlFor={"contact_number"}
            required
          />
          <RomanianPhoneInput
            inputError={inputError.contact}
            value={inputValues.contact}
            onChange={(value) => {
              setInputValues((prev) => ({ ...prev, contact: value }));
              setInputError((err) => ({ ...err, contact: false }));
            }}
          />
          {inputError.contact && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {t("contactRequired")}
            </FormHelperText>
          )}
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("country")} htmlFor={"country"} required />
          <TextInput id={"country"} type={"text"} value={"Romania"} readonly />
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("state")} htmlFor={"state"} required />
          <FormControl fullWidth error={inputError.state}>
            <Select
              name={"state"}
              value={inputValues.state}
              onChange={handleChangeValues}
              sx={{
                ...useStyle.selectStyle,
              }}
              readOnly={true}
            >
              <MenuItem value={""}>Select State</MenuItem>
              {allStates?.map((val, _i) => (
                <MenuItem key={val.id} value={val.name}>
                  {val.name}
                </MenuItem>
              ))}
            </Select>
            {inputError.state && (
              <FormHelperText sx={{ ml: 0 }}>
                {t("stateRequired")}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("city")} htmlFor={"city"} required />
          <FormControl fullWidth error={inputError.city}>
            <Select
              name={"city"}
              value={inputValues.city}
              onChange={handleChangeValues}
              sx={{
                ...useStyle.selectStyle,
              }}
            >
              <MenuItem value={""}>Select City</MenuItem>
              {allCities?.map((val, _i) => (
                <MenuItem key={val.id} value={val.name}>
                  {val.name}
                </MenuItem>
              ))}
            </Select>
            {inputError.city && (
              <FormHelperText sx={{ ml: 0 }}>
                {t("cityRequired")}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Stack
            mb={"5px"}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Label
              labelText={t("searchLocation")}
              htmlFor={"location"}
              required
              labelProps={{ marginBottom: 0 }}
            />
            <Stack direction={"row"}>
              <Label
                labelText={t("current")}
                htmlFor={"location"}
                labelProps={{ marginBottom: 0, fontSize: "0.775rem" }}
              />
              <LocationOnOutlinedIcon
                htmlColor={appcolors.black}
                sx={{ fontSize: "1.2rem" }}
              />
            </Stack>
          </Stack>

          <GooglePlacesAutocomplete
            apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
            autocompletionRequest={{
              componentRestrictions: {
                country: ["ro"],
              },
            }}
            selectProps={{
              styles: {
                control: (provided, state) => ({
                  ...provided,
                  padding: "4px",
                  borderRadius: "6px",
                  borderColor: inputError.location
                    ? theme.palette.error.main
                    : theme.palette.primary.main,
                  boxShadow: state.isFocused
                    ? `0 0 0 1px ${theme.palette.primary.main}`
                    : "none",
                  "&:hover": {
                    borderColor: theme.palette.primary.main,
                  },
                }),
              },
              value: location?.addresss,
              onChange: (e) => {
                setInputError((err) => ({ ...err, location: false }));
                setInputValues((prev) => ({ ...prev, location: e }));
                fetchPlaceDetails(e);
              },
            }}
          />

          {inputError.location && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {t("selectYourLocation")}
            </FormHelperText>
          )}

          {location && (
            <>
              <Label
                labelText={t("selectedAddress")}
                htmlFor={"location"}
                labelProps={{ mt: 1 }}
              />
              <TextInput
                id={"location"}
                required={true}
                inputError={inputError.location}
                helperText={inputError.location && t("locationRequired")}
                placeholder={`${t("enter")} ${t("location")}`}
                type={"text"}
                value={inputValues.location?.label}
                readonly
              />
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("expertise")} htmlFor={"expertise"} required />
          <FormControl fullWidth error={inputError.expertise}>
            <Select
              name={"expertise"}
              value={inputValues.expertise}
              onChange={handleChangeValues}
              sx={{
                ...useStyle.selectStyle,
              }}
            >
              <MenuItem value={""}>Select Expertise</MenuItem>
              {["Junior", "Intermediate", "Expert"].map((val, _i) => (
                <MenuItem key={_i} value={val}>
                  {t(val)}
                </MenuItem>
              ))}
            </Select>
            {inputError.expertise && (
              <FormHelperText sx={{ ml: 0 }}>
                {t("expertiseRequired")}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("gender")} htmlFor={"gender"} required />
          <FormControl fullWidth error={inputError.gender}>
            <Select
              name={"gender"}
              value={inputValues.gender}
              onChange={handleChangeValues}
              sx={{
                ...useStyle.selectStyle,
              }}
            >
              <MenuItem value={""}>Select Gender</MenuItem>
              {["Male", "Female", "Other"].map((val, _i) => (
                <MenuItem key={_i} value={val}>
                  {t(val)}
                </MenuItem>
              ))}
            </Select>
            {inputError.gender && (
              <FormHelperText sx={{ ml: 0 }}>
                {t("genderRequired")}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">{t("partnerCompanyDetails")}</Typography>
          {/* <Typography variant="body2">{t("listOfCompanies")}</Typography> */}
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText={t("selectCompany")}
            htmlFor={"worker-company"}
            required
          />
          <FormControl fullWidth error={inputError.company}>
            <Select
              name={"company"}
              value={inputValues.company}
              onChange={handleChangeValues}
              // disabled={true}
              readOnly={true}
              sx={{
                ...useStyle.selectStyle,
              }}
            >
              <MenuItem value={""}>{t("selectCompany")}</MenuItem>
              {allCompanies?.map((val, _i) => (
                <MenuItem key={_i} value={val._id} sx={{ gap: 1 }} divider>
                  <ListItemIcon>
                    <Avatar src={val.profileImg} />
                  </ListItemIcon>
                  <ListItemText primary={val.name} />
                </MenuItem>
              ))}
            </Select>
            {inputError.company && (
              <FormHelperText sx={{ ml: 0 }}>
                {t("companyIsRequired")}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Label labelText={t("password")} htmlFor={"password"} required />
          <TextInput
            inputError={inputError.password || inputError.isPasswordStrong}
            helperText={
              inputError.password
                ? t("passwordRequired")
                : inputError.isPasswordStrong
                ? t("passwordRequirements")
                : null
            }
            id={"password"}
            required
            placeholder={`${t("enter")} ${t("password")}`}
            type={showPass ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={handleChangeValues}
            InputEndIcon={
              showPass ? (
                <RemoveRedEyeIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowPass(false)}
                />
              ) : (
                <VisibilityOffIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setShowPass(true)}
                />
              )
            }
          />
        </Grid>
      </Grid>
      <Box mt={4}>
        <GlobalButton
          variant={"contained"}
          btnText={"letsCreateAccount"}
          handleClickBtn={handleRegister}
        />
      </Box>
    </Box>
  );
};

export default RegistrationForm;
